import { Uploader, UploadField } from '@navjobs/upload';
import React from 'react';
import { Accordion, Button, Dropdown, Grid, Icon, Segment } from 'semantic-ui-react';
import styled from 'styled-components';
import _ from 'lodash';
import moment from 'moment';
// import fileDownload from 'js-file-download';
import PropTypes from 'prop-types';

import { Dash } from 'components/Layout';
import Modal from 'components/Modal';
import { API, DOCUMENTS } from 'shared/constants';
import { getAuth } from 'shared/lib/request';
import AllegatoService from 'shared/services/api/allegato';
import GeneraDocumentoService from 'shared/services/rpc/genera-documento';

import IdentitaForm from '../../DocumentoIdentita';
import ErrorMessage from '../ErrorMessage';

const Progress = styled.div`
  transition: width 2s linear, opacity 0.2s linear;
  width: 0;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: green;
`;

const getDownloadBtnStyle = (toDisplay = true) => ({
  verticalAlign: 'top',
  position: 'relative',
  zIndex: 99,
  marginLeft: 8,
  marginRight: 0,
  display: toDisplay ? 'inline-block' : 'none',
});

const formatDate = (date) => (date ? moment.unix(date).format('DD/MM/YYYY') : <Dash />);

export class Upload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadId: props.downloadId || false,
      modalViewOpened: false,
      formData: {},

      dataScadenza: '',
      dataEmissione: '',
      numeroDocumento: '',
      ente: '',
      comune: '',
      provincia: '',
      allegatoIdentitaData: this.props.allegatoIdentitaData || {},
      activeIndex: null,

      downloading: false,
      downloadingVersion: false,
      generatingDocument: false,
      versions: [],
      createdBy: null,
    };
  }

  componentDidMount() {
    this.fetchVersions();
  }

  onUploadComplete = ({ response }) => {
    this.setState({ downloadId: response.id, allegatoIdentitaData: response });
    this.props.setAllegato(response.id);
    this.closeModal();
    this.fetchVersions();
  };

  getUrl = () => (this.state.downloadId ? `/${this.state.downloadId}` : '');

  getInitialValuesIdentityDocument = () => {
    /**
     * The ID document data are considered overvalued only if the field file is empty.
     * This means that no document has been uploaded as in the SPID process, where the data are uploaded but not the image.
     */
    if (!_.isEmpty(this.props.allegatoIdentitaData) && _.isEmpty(this.props.allegatoIdentitaData.file)) {
      return {
        id: '',
        dataScadenza: this.props.allegatoIdentitaData.dataScadenza
          ? moment.unix(this.props.allegatoIdentitaData.dataScadenza)
          : null,
        dataEmissione: this.props.allegatoIdentitaData.dataEmissione
          ? moment.unix(this.props.allegatoIdentitaData.dataEmissione)
          : null,
        numeroDocumento: this.props.allegatoIdentitaData.numeroDocumento,
        ente: ['Comune', 'Consolato', 'Ministero', 'Motorizzazione civile', 'Questura'].includes(
          this.props.allegatoIdentitaData.ente
        )
          ? this.props.allegatoIdentitaData.ente
          : null,
        comune: this.props.allegatoIdentitaData.comuneEmissione,
        provincia: this.props.allegatoIdentitaData.comuneEmissione.provincia,
        tipoDocumento: ['Carta identità', 'Passaporto', 'Patente'].includes(this.props.allegatoIdentitaData.discrOrigin)
          ? this.props.allegatoIdentitaData.discrOrigin
          : null,
      };
    }

    return null;
  };

  fetchVersions = () => {
    if ((this.props.showVersions || this.props.forceShowVersions) && this.state.downloadId) {
      AllegatoService.getById(this.state.downloadId, this.props.endpoint).then((res) => {
        const versions = _.map(res.versions, (version, id) => ({ ...version, id }));
        this.setState({ versions, createdBy: res.createdBy });
      });
    }
  };

  handleClick = (_event, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({ activeIndex: newIndex });
  };

  download = (versionOrEvent) => {
    let version = false;
    let stateKey = 'downloading';

    // versionOrEvent can be an event (click) if normal download, string when retrieving a version
    if (typeof versionOrEvent === 'string') {
      version = versionOrEvent;
      stateKey += 'Version';
    }

    this.setState({ [stateKey]: true });
    if (this.state.downloadId) {
      AllegatoService.getFileById(this.state.downloadId, this.props.endpoint, version)
        .then((res) => {
          const disposition = res.headers['content-disposition'];
          const type = res.headers['content-type'];
          const filename = decodeURI(disposition.match(/filename=(.*)/)[1]);
          // fileDownload(res.data, filename);
          this.showFile(res.data, type, filename);
        })
        .catch((error) => this.blobToString(error.data))
        .finally(() => this.setState({ [stateKey]: false }));
    }
  };

  downloadVersion = (event, versionId) => {
    event.preventDefault();
    event.stopPropagation();
    this.download(versionId);
  };

  showFile = (blob, type) => {
    const file = new Blob([blob], { type });
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL);
  };

  beforeSend = (onFiles, data) => {
    if (this.props.showForm) {
      this.setState({ formData: data }, this.openModal);
    } else {
      onFiles(data);
    }
  };

  sendWithData = (data, onFiles) => {
    this.setState({ ...data }, () => onFiles(this.state.formData));
  };

  generateDocument = () => {
    this.setState({ generatingDocument: true });

    GeneraDocumentoService.getContratto(this.props.collaboratoreId)
      .then((res) => {
        const disposition = res.headers['content-disposition'];
        const type = res.headers['content-type'];
        const filename = decodeURI(disposition.match(/filename=(.*)/)[1]);
        // fileDownload(res.data, filename);
        this.showFile(res.data, type, filename);
      })
      .catch((error) => this.blobToString(error.data))
      .finally(() => this.setState({ generatingDocument: false }));
  };

  closeModal = () =>
    this.setState({ modalViewOpened: false }, () => document.body.classList.add('scrolling', 'dimmable', 'dimmed'));

  openModal = () => this.setState({ modalViewOpened: true });

  buildPayload = () => {
    const payload = {};

    if (this.state.downloadId) {
      payload.id = this.state.downloadId;
    }

    if (this.state.dataScadenza) {
      payload.dataScadenza = this.state.dataScadenza;
    }

    if (this.state.dataEmissione) {
      payload.dataEmissione = this.state.dataEmissione;
    }

    if (this.state.numeroDocumento) {
      payload.numeroDocumento = this.state.numeroDocumento;
    }

    if (this.state.ente) {
      payload.ente = this.state.ente;
    }

    if (this.state.comune) {
      payload.comuneEmissione = this.state.comune;
    }

    if (this.state.provincia) {
      payload.provinciaEmissione = this.state.provincia;
    }

    if (this.state.tipoDocumento) {
      payload.discrOrigin = this.state.tipoDocumento;
    }

    if (this.props.anagraficaId) {
      payload.anagrafica = this.props.anagraficaId;
    }

    if (this.props.collaboratoreId) {
      payload.collaboratore = this.props.collaboratoreId;
    }

    if (this.props.tipoFirma) {
      payload.tipoFirma = this.props.tipoFirma;
    }

    return payload;
  };

  render() {
    const { allegatoIdentitaData } = this.state;
    const { touched, errors, name } = this.props;

    const disabledUpload = (this.props.disableUlAfterOne && this.state.downloadId) || this.props.disabled;
    const showVersions =
      (this.props.forceShowVersions && this.state.versions.length > 0) ||
      (this.props.showVersions && this.state.versions.length > 1);
    const titleColumnWidth =
      12 - (this.props.collaboratoreId && this.state.downloadId ? 1 : 0) - (showVersions ? 1 : 0);

    return (
      <Uploader
        request={{
          fileName: 'file',
          url: `${API.BASEURL}${this.props.endpoint}${this.getUrl()}`,
          method: this.state.downloadId ? 'PUT' : 'POST',
          fields: this.buildPayload(),
          headers: {
            Authorization: getAuth(),
          },
          withCredentials: false,
        }}
        // onError={(error) => console.log('ERROR', error)}
        onComplete={this.onUploadComplete}
        // Upload on file selection, otherwise use `startUpload`
        uploadOnSelection
        reset
        onError={(error) => {
          if (this.props.onError) {
            this.props.onError(error, this.state, this.closeModal);
          }
        }}
      >
        {({ onFiles, progress, complete, error, response }) => (
          <Segment style={{ boxShadow: 'none' }}>
            <Grid>
              <Grid.Column width={titleColumnWidth} style={{ transform: 'translate3d(0, 0, 0)' }}>
                <Progress
                  className="upload-progress"
                  style={{ width: `${progress}%`, opacity: !progress || error ? 0 : 0.2 }}
                />
                <Grid>
                  {/* complete ? complete.toString() : ''*/}
                  <Grid.Column width={this.props.showForm ? 10 : 16}>
                    <Grid.Row>
                      <b>{this.props.title}</b>
                    </Grid.Row>

                    <Grid.Row style={{ fontSize: 11 }}>
                      {this.props.description}
                      {this.props.endpoint === DOCUMENTS.PRIVACY && this.state.createdBy ? (
                        <div style={{ paddingTop: '4px' }}>Caricata da: {this.state.createdBy}</div>
                      ) : null}
                    </Grid.Row>
                    {error
                      ? _.values(_.get(response, 'validation_messages.file', {})).map((msg) => (
                        <Grid.Row style={{ padding: '15px 0' }}>
                          <b style={{ color: '#f00' }}>{msg}</b>
                        </Grid.Row>
                      ))
                      : ''}
                  </Grid.Column>

                  {_.get(allegatoIdentitaData, 'dataEmissione') && (
                    <Grid.Column width={16} style={{ fontSize: 11, marginTop: -31 }}>
                      {/* <div>Tipo Documento: {}</div>*/}
                      <Accordion>
                        <Accordion.Title active={this.state.activeIndex === 0} index={0} onClick={this.handleClick}>
                          <Icon name="dropdown" />
                          Dati del documento
                        </Accordion.Title>

                        <Accordion.Content
                          active={this.state.activeIndex === 0}
                          style={{ marginTop: -10, marginLeft: 17 }}
                        >
                          <div>
                            <b>Tipo:</b> {allegatoIdentitaData.discrOrigin || <Dash />}
                          </div>
                          <div>
                            <b>Comune:</b> {allegatoIdentitaData.comuneEmissione || <Dash />}
                          </div>
                          <div>
                            <b>Ente:</b> {allegatoIdentitaData.ente || <Dash />}
                          </div>
                          <div>
                            <b>Numero:</b> {allegatoIdentitaData.numeroDocumento || <Dash />}
                          </div>
                          <div>
                            <b>Emesso:</b> {formatDate(allegatoIdentitaData.dataEmissione)}
                          </div>
                          <div>
                            <b>Scade:</b> {formatDate(allegatoIdentitaData.dataScadenza)}
                          </div>
                        </Accordion.Content>
                      </Accordion>
                    </Grid.Column>
                  )}
                </Grid>
              </Grid.Column>

              <Grid.Column width={16 - titleColumnWidth} textAlign="center" style={{ borderLeft: '1px solid #ccc' }}>
                <div style={{ display: 'table', height: '100%', width: '100%' }}>
                  <div
                    style={{
                      display: 'table-cell',
                      height: '100%',
                      width: '100%',
                      textAlign: 'center',
                      verticalAlign: 'middle',
                    }}
                  >
                    {!this.props.hideUpload && (
                      <UploadField
                        onFiles={(data) => this.beforeSend(onFiles, data)}
                        containerProps={{
                          style: {
                            overflow: 'hidden',
                            width: '36px',
                            position: 'relative',
                            display: 'inline-block',
                            pointerEvents: disabledUpload ? 'none' : 'auto',
                          },
                          className: 'uploadHoverable',
                        }}
                      >
                        <Button
                          type="button"
                          loading={progress > 0 && !complete && !error}
                          circular
                          color={this.props.buttonUlColor || 'blue'}
                          disabled={disabledUpload}
                          icon="upload"
                        />

                        <Modal size="mini" hiddenHeader open={this.state.modalViewOpened} onClose={this.closeModal}>
                          <IdentitaForm
                            close={this.closeModal}
                            anagraficaId={this.props.anagraficaId}
                            sendWithData={this.sendWithData}
                            onFiles={onFiles}
                            initialValues={this.getInitialValuesIdentityDocument()}
                          />
                        </Modal>
                      </UploadField>
                    )}

                    <Button
                      type="button"
                      circular
                      color={this.props.buttonDlColor}
                      icon="download"
                      loading={this.state.downloading}
                      style={getDownloadBtnStyle(this.state.downloadId)}
                      onClick={this.download}
                    />

                    {this.props.collaboratoreId && (
                      <Button
                        type="button"
                        circular
                        color={this.props.buttonDlColor}
                        icon="retweet"
                        loading={this.state.generatingDocument}
                        style={getDownloadBtnStyle()}
                        onClick={this.generateDocument}
                      />
                    )}

                    {showVersions && (
                      <Dropdown
                        button
                        className="icon circular"
                        icon="history"
                        loading={this.state.downloadingVersion}
                        style={getDownloadBtnStyle()}
                      >
                        <Dropdown.Menu>
                          {this.state.versions.map((version) => (
                            <Dropdown.Item key={version.id} onClick={(e) => this.downloadVersion(e, version.id)}>
                              <div>{version.name}</div>
                              <div style={{ fontSize: 10, color: '#333d68' }}>{version.date}</div>
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </div>
                </div>
              </Grid.Column>
            </Grid>

            <div style={this.props.errorContainerStyle || { position: 'absolute', bottom: 7 }}>
              {touched && name && touched[name] && errors[name] && (
                <ErrorMessage style={this.props.errorMessageStyle}>{errors[name]}</ErrorMessage>
              )}
            </div>
          </Segment>
        )}
      </Uploader>
    );
  }
}

Upload.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  downloadId: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  setAllegato: PropTypes.func,
  hideUpload: PropTypes.bool,
  buttonUlColor: PropTypes.string,
  buttonDlColor: PropTypes.string,
  disableUlAfterOne: PropTypes.bool,
  endpoint: PropTypes.string,
  showForm: PropTypes.string,
  anagraficaId: PropTypes.string,
  allegatoIdentitaData: PropTypes.object,
  collaboratoreId: PropTypes.string,
  touched: PropTypes.any,
  errors: PropTypes.any,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  showVersions: PropTypes.bool,
  /** Set this props to true if want to force versions button not only when there is more then one version */
  forceShowVersions: PropTypes.bool,
  tipoFirma: PropTypes.number,
  errorContainerStyle: PropTypes.object,
  errorMessageStyle: PropTypes.object,
  onError: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/components/Forms/UI/Upload/index.js